// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__O1SV+","visible":"BackToTop_visible__4p8UN","slideInRight":"BackToTop_slideInRight__NNaZu","bounce":"BackToTop_bounce__-Di+k"};